export default __webpack_public_path__ + "static/media/auditorium-text-hover.13864692.png";